import { PAGE_LINKS } from '@/helpers/commonConsts'
import { lazy } from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import { AuthRenderer } from './AdminPage/components/AuthRenderer'
import Loadable from '@/router/loadable'
import { AdminApp } from './adminApp'

const AdminLoginPage = Loadable(lazy(() => import('./LoginPage')))
const AdminLayout = Loadable(lazy(() => import('./AdminPage/index')))
const WorkbenchPage = Loadable(lazy(() => import('./AdminPage/pages/WorkbenchPage')))
const CoursePage = Loadable(lazy(() => import('./AdminPage/pages/CoursePage')))
const CourseCreatePage = Loadable(lazy(() => import('./AdminPage/pages/CoursePage/pages/CreatePage')))
const SeriesCoursePage = Loadable(lazy(() => import('./AdminPage/pages/SeriesCoursePage')))
const SeriesCourseCreatePage = Loadable(lazy(() => import('./AdminPage/pages/SeriesCoursePage/pages/CreatePage')))
const SeriesCourseDetailPage = Loadable(lazy(() => import('./AdminPage/pages/SeriesCoursePage/pages/DetailPage')))
const SpecialSeriesCoursePage = Loadable(lazy(() => import('./AdminPage/pages/SpecialSeriesCoursePage')))
const SpecialSeriesCourseCreatePage = Loadable(
  lazy(() => import('./AdminPage/pages/SpecialSeriesCoursePage/pages/CreatePage')),
)
const SpecialSeriesCourseDetailPage = Loadable(
  lazy(() => import('./AdminPage/pages/SpecialSeriesCoursePage/pages/DetailPage/index')),
)
const CourseAttrPage = Loadable(lazy(() => import('./AdminPage/pages/CourseAttrPage')))
const OrderPage = Loadable(lazy(() => import('./OrderManage/OrderListPage')))
const PermissionPage = Loadable(lazy(() => import('./AdminPage/pages/PermissionPage')))
const UserManagePage = Loadable(lazy(() => import('./AdminPage/pages/UserManage')))
const FrontUserManagePage = Loadable(lazy(() => import('./AdminPage/pages/FrontUserManage')))
const FrontUserDetailPage = Loadable(lazy(() => import('./AdminPage/pages/FrontUserManage/pages/DetailPage')))
const CouponManagePage = Loadable(lazy(() => import('./CouponManage/index')))
const CouponDetailPage = Loadable(lazy(() => import('./CouponManage/DetailPage')))
const CouponEditPage = Loadable(lazy(() => import('./CouponManage/EditPage')))
const CouponCreatePage = Loadable(lazy(() => import('./CouponManage/CreatePage')))
// const OrderDetail= Loadable(lazy(() => import('./OrderManage/OrderDetailPage')))

// 辅助函数：创建带权限验证的路由
const createAuthRoute = (path: string, element: React.ReactNode, permission?: string): RouteObject => {
  return {
    path,
    element: permission ? (
      <AuthRenderer requiredPermission={permission}>
        {element}
      </AuthRenderer>
    ) : (
      <AuthRenderer>{element}</AuthRenderer>
    ),
  }
}

const DASHBOARD_ROUTES: RouteObject[] = [
  {
    path: '',
    element: <Navigate to={PAGE_LINKS.adminWorkbench} replace />,
  },
  // 工作台 - 不需要特定权限，登录即可访问
  createAuthRoute(PAGE_LINKS.adminWorkbench, <WorkbenchPage />),
  // 课程管理模块 - 父菜单 key: 'course'，包含课件列表、系列课列表、特殊系列课列表
  createAuthRoute(PAGE_LINKS.adminCourseList, <CoursePage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminCourseCreate, <CourseCreatePage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminSeriesCourseList, <SeriesCoursePage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminSeriesCourseCreate, <SeriesCourseCreatePage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminSeriesCourseDetail, <SeriesCourseDetailPage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminSpecialSeriesCourseList, <SpecialSeriesCoursePage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminSpecialSeriesCourseCreate, <SpecialSeriesCourseCreatePage />, 'course'),
  createAuthRoute(PAGE_LINKS.adminSpecialSeriesCourseDetail, <SpecialSeriesCourseDetailPage />, 'course'),
  // 课程基础属性管理 - 对应菜单 key: 'goods_attr'
  createAuthRoute(PAGE_LINKS.adminCourseAttr, <CourseAttrPage />, 'goods_attr'),
  // 订单管理 - 对应菜单 key: 'order'
  createAuthRoute(PAGE_LINKS.adminOrderList, <OrderPage />, 'order'),
  // 优惠券管理 - 对应菜单 key: 'order'（与订单管理共用权限）
  createAuthRoute(PAGE_LINKS.adminCouponList, <CouponManagePage />, 'order'),
  createAuthRoute(PAGE_LINKS.adminCouponDetail, <CouponDetailPage />, 'order'),
  createAuthRoute(PAGE_LINKS.adminCouponEdit, <CouponEditPage />, 'order'),
  createAuthRoute(PAGE_LINKS.adminCouponCreate, <CouponCreatePage />, 'order'),
  // 后台用户权限管理 - 父菜单 key: 'role'，包含角色权限管理、用户管理
  createAuthRoute(PAGE_LINKS.adminPermission, <PermissionPage />, 'role'),
  createAuthRoute(PAGE_LINKS.adminUserManage, <UserManagePage />, 'role'),
  // 前台用户管理 - 对应菜单 key: 'user'
  createAuthRoute(PAGE_LINKS.adminFrontUserManage, <FrontUserManagePage />, 'user'),
  createAuthRoute(PAGE_LINKS.adminFrontUserDetail, <FrontUserDetailPage />, 'user'),
  // {
  //   path: PAGE_LINKS.adminOrderDetail,
  //   element: <OrderDetail />,
  // },
  // {
  //   path: PAGE_LINKS.,
  //   element: <CourseAttrPage />,
  // },
  {
    /** NOT FOUND */
    path: '*',
    element: <Navigate to={PAGE_LINKS.adminWorkbench} replace />,
  },
]

const adminRoutes: RouteObject[] = [
  {
      path: PAGE_LINKS.adminLogin,
      element: <AdminLoginPage />,
  },
  {
    path: PAGE_LINKS.admin,
    element: <AdminApp />,
    children: [
      {
        path: PAGE_LINKS.admin,
        element: (
          <AuthRenderer>
            <AdminLayout />
          </AuthRenderer>
        ),
        children: DASHBOARD_ROUTES,
      },
    
    ],
  },
]

export default adminRoutes
